import { payPeriods, payPeriodLabels, type PayPeriod } from "@shared/schema";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

interface PayPeriodSelectorProps {
  value: PayPeriod;
  onChange: (value: PayPeriod) => void;
  className?: string;
}

export function PayPeriodSelector({ value, onChange, className }: PayPeriodSelectorProps) {
  return (
    <ToggleGroup 
      type="single" 
      value={value} 
      onValueChange={(v) => v && onChange(v as PayPeriod)}
      className={`flex flex-wrap gap-1 ${className}`}
    >
      {payPeriods.map((period) => (
        <ToggleGroupItem 
          key={period}
          value={period}
          aria-label={payPeriodLabels[period]}
          className="px-3 py-1.5 text-sm"
          data-testid={`toggle-period-${period}`}
        >
          {payPeriodLabels[period]}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
